import hero1 from "./1-1.webp";
import hero2 from "./2.webp";
import hero3 from "./3.webp";
import hero4 from "./4.webp";

const heroimg = [hero1, hero2, hero3, hero4];

export default heroimg;
